export default __webpack_public_path__ + "36deb6b5423aa02bc1aa2833fc70b4a6.jpg";